/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Specifies the encoding type used for data representation.
 */
export enum EncodingType {
  EncodingPlain = 'plain',
  EncodingBase64 = 'base64',
}
